<template>
    <div
        class="container flex flex-col items-center justify-center text-center space-y-8"
    >
        <Empty class="w-60 h-auto mx-auto" />
        <p class="text-gray-600 text-base sm:text-normal">{{ text }}</p>
    </div>
</template>

<script setup>
import Empty from '../icons/Empty.vue'

defineProps({
    text: {
        default: 'There is no data available.',
        type: String,
    },
});
</script>
